import { DisplaySet } from '../../displaySet/model/DisplaySet'
import { IdType } from '../../util/models/IdType'
import { SimpleItem } from './SimpleItem'

export const hasDisplaySet = ({item, displaySetId} : {item :SimpleItem, displaySetId: IdType}) => {
    return item.displaySets.some((displaySet : DisplaySet) => displaySet.id === displaySetId)
} 
